// extracted by mini-css-extract-plugin
module.exports = {"hero":"bj_fw"};